import React from "react";
import { Link } from "react-router-dom";
import "../Signup/style.css";
import AuthLayout from "../../components/new-design/auth-layout";

export default function SignInError() {
  return (
    <AuthLayout>
      <div className="form__block position-relative rounded p-3 shadow">
        {/* <h1 className="d-flex flex-column text-white h2">
          <span>Welcome back</span>
          <span>to Dropzik</span>
        </h1> */}
        <p className="fs-14">
          New here? {` `}
          <a href="https://www.dropzik.com/apply" className="primary-link text-decoration-none">
            Sign up now
          </a>
          {` `}and start your journey.
        </p>
        <div className="mt-5 mb-5">
          <div className="text-white h5 font-bold mb-3">⚠ Sign-in error</div>
          <p className="m-0">
            <div>An unexpected error occurred. Please try again.</div>
            <div>
              If the issue persists, please contact our support team via <a href="https://wa.me/+18077899556?text=i%20need%20help%20with%20my%20signin" className="primary-link">WhatsApp - (+1 807-789-9556)</a>, email (<a
                href="mailto://Support@dropzik.com"
                className="primary-link text-decoration-none"
              >support@dropzik.com</a>), or visit our <a href="https://intercom.help/dropzik-digital-canada/" className="primary-link text-decoration-none">Help Center</a> for further assistance.
            </div>
          </p>
        </div>
        <Link
          to="/signin"
          className="rounded-0 border-0 btn btn-primary btn-block btn-lg primary-btn-outline"
        >
          Back to login
        </Link>
        <p className="text-white fs-12 mt-4 signin__footer">
          By signing in, you agree to{` `}
          <a
            href="https://www.dropzik.com/terms"
            className="text-muted"
          >
            our Terms of Service{` `}
          </a>
          and{` `}
          <a
            href="https://new.dropzik.com/license"
            className="text-muted"
          >
            Privacy Policy
          </a>.
        </p>
      </div>
    </AuthLayout>
  );
}
